module.exports = __webpack_public_path__ + "static/media/1POLICY20.2eb7a2fa.jpg";